import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import {
  BalancePage,
  BasketPage,
  EmailVerifiedPage,
  OrdersPage,
  ResetPasswordPage,
  SearchPage,
  ShipmentsPage,
  AboutPage,
  ContactPage,
  CatalogPage,
  BankPage,
  ManualsPage,
  HomePage,
  NewsPortal,
  PageNews,
  RegisterPage,
  LoginPage,
  ProfilePage,
  VerifyPaymentPage,
} from './pages';

function AppRouter() {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={HomePage} />
        <Route exact path="/search" component={SearchPage} />
        <Route exact path="/cart" component={BasketPage} />
        <Route exact path="/orders" component={OrdersPage} />
        <Route exact path="/dispatch" component={ShipmentsPage} />
        <Route exact path="/balance" component={BalancePage} />
        <Route exact path="/reset-password" component={ResetPasswordPage} />
        <Route exact path="/email-verified" component={EmailVerifiedPage} />
        <Route exact path="/about" component={AboutPage} />
        <Route exact path="/contacts" component={ContactPage} />
        <Route exact path="/bank" component={BankPage} />
        <Route exact path="/offers" component={CatalogPage} />
        <Route exact path="/manuals" component={ManualsPage} />
        <Route exact path="/news" component={NewsPortal} />
        <Route exact path="/news/:postID" component={PageNews} />
        <Route exact path="/register" component={RegisterPage} />
        <Route exact path="/login" component={LoginPage} />
        <Route exact path="/profile" component={ProfilePage} />
        <Route exact path="/payment-result" component={VerifyPaymentPage} />
        <Redirect to="/search" />
      </Switch>
    </Router>
  );
}

export default AppRouter;
